import React from "react";
import "../Style/NavBar.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../icons/Logo";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Collection", to: "/contact-us" },
  { label: "Our Story", to: "/our-story" },
  { label: "Reserve", to: "/reserve-occaission" },
];

function NavBar() {
  const { pathname } = useLocation();

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <span className="navbar-logo-svg">
          <Logo aria-hidden="true" />
        </span>
        <div className="navbar-logo-text">
          <span className="navbar-logo-name">Up &amp; Away</span>
          {/* <span className="navbar-logo-sub">Atelier</span> */}
        </div>
      </div>

      <div className="navbar-links">
        {NAV_LINKS.map((link) => (
          <Link
            key={link.label}
            to={link.to}
            className={`navbar-link${pathname === link.to ? " active" : ""}`}
          >
            {link.label}
          </Link>
        ))}
      </div>

      {/* <div className="navbar-actions">
        <button className="navbar-icon-btn" aria-label="Search">
          <SearchIcon />
        </button>
        <button className="navbar-icon-btn" aria-label="Bag">
          <BagIcon />
        </button>
        <button className="navbar-icon-btn" aria-label="Account">
          <UserIcon />
        </button>
        <div className="navbar-divider" />
        <button className="navbar-cta">Begin Your Journey</button>
      </div> */}
    </nav>
  );
}

export default NavBar;
